//STYLES

import './styles/Hero.css';

export default function Hero() {
	return (
		<div className="header header-hero">
			<main className="container hero">
				<div className="hero-text">
					<h1>More than just shorter links</h1>
					<p>
						Build your brand’s recognition and get detailed insights on how your
						links are performing.
					</p>
					<button>Get Started</button>
				</div>
			</main>
		</div>
	);
}
